<div class="financial-section">
  <span class="ml-3">{{ 'site.financial.disclaimer' | translate }}</span>
</div>
